import { ViewBox } from '@/utils/svgPathParser';
import { LINE_STYLES, COLORS } from './constants';

type CenterLinesProps = {
  viewBox: ViewBox;
};

export function CenterLines({ viewBox: vb }: CenterLinesProps) {
  const centerX = vb.minX + vb.width / 2;
  const centerY = vb.minY + vb.height / 2;
  const overshoot = 3;

  return (
    <g className="center-lines" opacity={0.3}>
      {/* Horizontal centerline */}
      <line
        x1={vb.minX - overshoot}
        y1={centerY}
        x2={vb.minX + vb.width + overshoot}
        y2={centerY}
        stroke={COLORS.dimension}
        strokeWidth={LINE_STYLES.centerline.strokeWidth}
        strokeDasharray={LINE_STYLES.centerline.dashArray}
      />
      {/* Vertical centerline */}
      <line
        x1={centerX}
        y1={vb.minY - overshoot}
        x2={centerX}
        y2={vb.minY + vb.height + overshoot}
        stroke={COLORS.dimension}
        strokeWidth={LINE_STYLES.centerline.strokeWidth}
        strokeDasharray={LINE_STYLES.centerline.dashArray}
      />
    </g>
  );
}
